// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-signals-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.ai-signals-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.ai-signals-title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin: 0 0 0.25rem 0;
}

.ai-signals-subtitle {
  color: #666;
  margin: 0;
  font-size: 0.9rem;
}

.run-analysis-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.4rem;
  background: #7b1fa2;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.run-analysis-btn:hover:not(:disabled) {
  background: #6a1b9a;
}

.run-analysis-btn:disabled {
  background: #9c27b0;
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.ai-signals-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: #f5f5f5;
  border-radius: 8px;
}

.ai-signals-controls label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: #333;
}

.date-picker {
  padding: 0.4rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
}

.refresh-btn {
  padding: 0.4rem 1rem;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.refresh-btn:hover {
  background: #eee;
}

.run-result {
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.run-result.success {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.run-result.error {
  background: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

.run-result.info {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}

.error-message {
  padding: 0.75rem 1rem;
  background: #ffebee;
  color: #c62828;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem;
  gap: 1rem;
  color: #666;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top-color: #7b1fa2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.empty-message {
  text-align: center;
  padding: 3rem;
  color: #999;
}

.empty-message p {
  margin: 0.25rem 0;
}

.signals-summary {
  margin-bottom: 1rem;
  padding: 0.5rem 0.75rem;
  background: #f3e5f5;
  border-radius: 4px;
  color: #6a1b9a;
  font-size: 0.9rem;
  font-weight: 500;
}

.signals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

.signal-card {
  background: white;
  border-radius: 10px;
  padding: 1.1rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.signal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.signal-symbol {
  font-size: 1.4rem;
  font-weight: 700;
  color: #111;
  font-family: 'Courier New', monospace;
}

.signal-score {
  color: white;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
}

.signal-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.signal-action {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.action-badge {
  padding: 0.15rem 0.6rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
}

.action-buy {
  background: #e8f5e9;
  color: #2e7d32;
}

.action-sell {
  background: #ffebee;
  color: #c62828;
}

.sentiment-badge {
  padding: 0.15rem 0.6rem;
  border-radius: 4px;
  font-size: 0.75rem;
  background: #e3f2fd;
  color: #1565c0;
}

.signal-reason {
  font-size: 0.88rem;
  color: #444;
  line-height: 1.45;
  margin: 0;
  flex: 1 1;
}

.signal-footer {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #999;
  border-top: 1px solid #f0f0f0;
  padding-top: 0.5rem;
}

@media (max-width: 600px) {
  .ai-signals-page {
    padding: 1rem;
  }

  .ai-signals-header {
    flex-direction: column;
  }

  .signals-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AiSignals.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".ai-signals-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.ai-signals-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.ai-signals-title {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #333;\n  margin: 0 0 0.25rem 0;\n}\n\n.ai-signals-subtitle {\n  color: #666;\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.run-analysis-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.4rem;\n  background: #7b1fa2;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s;\n}\n\n.run-analysis-btn:hover:not(:disabled) {\n  background: #6a1b9a;\n}\n\n.run-analysis-btn:disabled {\n  background: #9c27b0;\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.ai-signals-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.ai-signals-controls label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.date-picker {\n  padding: 0.4rem 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.95rem;\n}\n\n.refresh-btn {\n  padding: 0.4rem 1rem;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.refresh-btn:hover {\n  background: #eee;\n}\n\n.run-result {\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.run-result.success {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid #a5d6a7;\n}\n\n.run-result.error {\n  background: #ffebee;\n  color: #c62828;\n  border: 1px solid #ef9a9a;\n}\n\n.run-result.info {\n  background: #e3f2fd;\n  color: #1565c0;\n  border: 1px solid #90caf9;\n}\n\n.error-message {\n  padding: 0.75rem 1rem;\n  background: #ffebee;\n  color: #c62828;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem;\n  gap: 1rem;\n  color: #666;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top-color: #7b1fa2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 3rem;\n  color: #999;\n}\n\n.empty-message p {\n  margin: 0.25rem 0;\n}\n\n.signals-summary {\n  margin-bottom: 1rem;\n  padding: 0.5rem 0.75rem;\n  background: #f3e5f5;\n  border-radius: 4px;\n  color: #6a1b9a;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.signals-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n.signal-card {\n  background: white;\n  border-radius: 10px;\n  padding: 1.1rem;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\n  border: 1px solid #eee;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.signal-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.signal-symbol {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #111;\n  font-family: 'Courier New', monospace;\n}\n\n.signal-score {\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.2rem 0.6rem;\n  border-radius: 20px;\n}\n\n.signal-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.signal-action {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.action-badge {\n  padding: 0.15rem 0.6rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.action-buy {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.action-sell {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.sentiment-badge {\n  padding: 0.15rem 0.6rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.signal-reason {\n  font-size: 0.88rem;\n  color: #444;\n  line-height: 1.45;\n  margin: 0;\n  flex: 1;\n}\n\n.signal-footer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.75rem;\n  color: #999;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 0.5rem;\n}\n\n@media (max-width: 600px) {\n  .ai-signals-page {\n    padding: 1rem;\n  }\n\n  .ai-signals-header {\n    flex-direction: column;\n  }\n\n  .signals-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
